import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      const sessionId = m ? decodeURIComponent(m[1]) : null;
      if (!sessionId) { navigate("/login"); return; }
      try {
        await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        await refresh();
        window.history.replaceState(null, "", "/account");
        navigate("/account");
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-5">
      {error ? (
        <p className="text-[#B0341F]" data-testid="oauth-error">{error}</p>
      ) : (
        <>
          <Loader2 size={40} className="animate-spin text-[#306D29] mb-5" />
          <p className="font-display text-2xl text-[#0D530E]">Signing you in…</p>
        </>
      )}
    </div>
  );
}
